const $6e61e9ae0da49751$var$rules = [
    // substitutions
    [
        /ä/g,
        'a'
    ],
    [
        /ö/g,
        'o'
    ],
    [
        /ü/g,
        'u'
    ],
    [
        /ß/g,
        'ss'
    ],
    [
        /[^a-z]/g,
        ''
    ],
    // complex rules
    [
        /[dt](?![csz])/g,
        '2'
    ],
    [
        /[dt](?=[csz])/g,
        '8'
    ],
    [
        /[ckq]x/g,
        '88'
    ],
    [
        /[sz]c/g,
        '88'
    ],
    [
        /^c(?=[ahkloqrux])/,
        '4'
    ],
    [
        /^c/,
        '8'
    ],
    [
        /c(?=[ahkoqux])/g,
        '4'
    ],
    [
        /c$/,
        '4'
    ],
    [
        /x/g,
        '48'
    ],
    [
        /p(?!h)/g,
        '1'
    ],
    [
        /p(?=h)/g,
        '3'
    ],
    // simple rules
    [
        /h/g,
        ''
    ],
    [
        /[aeijouy]/g,
        '0'
    ],
    [
        /b/g,
        '1'
    ],
    [
        /[fvw]/g,
        '3'
    ],
    [
        /[gkq]/g,
        '4'
    ],
    [
        /l/g,
        '5'
    ],
    [
        /[mn]/g,
        '6'
    ],
    [
        /r/g,
        '7'
    ],
    [
        /[csz]/g,
        '8'
    ],
    // modifiers
    [
        /([^\w\s])|(.)(?=\2)/g,
        ''
    ],
    [
        /\B0/g,
        ''
    ] // remove 0s except for first char
];
const $6e61e9ae0da49751$export$c50eaa852b7e5bd7 = (phrase)=>$6e61e9ae0da49751$var$rules.reduce((kph, [search, replace])=>kph.replace(search, replace), phrase.toLowerCase());


const $b4e14b6b8da86996$var$input = document.getElementById('input');
const $b4e14b6b8da86996$var$output = document.getElementById('output');
function $b4e14b6b8da86996$var$renderColognePhonetic() {
    const phrases = $b4e14b6b8da86996$var$input.value.split('\n');
    $b4e14b6b8da86996$var$input.setAttribute('rows', String(phrases.length));
    $b4e14b6b8da86996$var$output.setAttribute('rows', String(phrases.length));
    $b4e14b6b8da86996$var$output.value = phrases.map((0, $6e61e9ae0da49751$export$c50eaa852b7e5bd7)).join('\n');
}
$b4e14b6b8da86996$var$input.addEventListener('input', $b4e14b6b8da86996$var$renderColognePhonetic);
$b4e14b6b8da86996$var$renderColognePhonetic();


//# sourceMappingURL=cologne-phonetic.e98fab3a.js.map
